import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
let inject = ['$scope', '$timeout', '$uibModalInstance', 'modalOptions', 'SharedService', 'SessionService', '$state', '$uibModal','CartService','ngAuthSettings','$window'];

class ModalMoraController {
    constructor($scope, $timeout, $uibModalInstance, modalOptions, SharedService, SessionService, $state, $uibModal,CartService,ngAuthSettings,$window) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.SharedService = SharedService;
        this.$state = $state;
        this.SessionService = SessionService;
        this.$uibModalInstance = $uibModalInstance;
        this.$uibModal = $uibModal;
        this.modalOptions = Object.assign({}, modalOptions);
        this.state = {};
        this.branchUserB2B = {};
        this.registerDataForm = {};
        this.CartService = CartService;
        this.messageBody = '';
        this.ngAuthSettings = ngAuthSettings;
        this.mensajeMora = '';
        this.$window = $window;
    }

    $onInit() {
        this.mensajeMora = this.modalOptions.shCtrl.params.cmsInfo.B2B_MENSAJE_INFORMATIVO_PAGAR_MORA;
    }
    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

    ok() {
        this.$uibModalInstance.close(this.$scope);
    }

    confirmarPedidoSinAutorizacion(){
        this.state.saving = true;
        let orderDataForm = this.modalOptions;
        let validaVolumen = this.ngAuthSettings.site.info.company.validacionVolumenCompra;

        if(validaVolumen){
          this.verificarReglaCoberturaMora(orderDataForm);
        }else{
          this.guardarDataPedido(orderDataForm);
        }
      }

      guardarDataPedido(orderDataForm){
        delete orderDataForm.shCtrl;
        this.CartService.saveCartOrderData(orderDataForm).then(response => {
          this.state.saving = false;
          if (!response.error) {
            this.savedOrderCart = true;
            orderDataForm.comment = '';
            this.cancel();
            this.$state.go('home.tunnel');
          } else {
            let errorMessageSavingOrderCart = response.message;
            this.state.saving = false;
            let messageTitle = response.errorCode === 'EVMP' ? 'El pedido no puede ser procesado' : 'Debes diligenciar algunos datos aún...';
            let options = {
              title: messageTitle,
              isHtml: true,
              content: errorMessageSavingOrderCart,
              size: '',
              showBottonCancel: false,
              textActionCancel: '',
              textAction: 'Aceptar'
            };
            this.messageResponse(options);
          }
        }).catch(reason => {
          this.savingOrderCart = false;
          this.savedOrderCart = false;
          this.errorSavingOrderCart = true;
          let options = {
            title: '',
            isHtml: false,
            content: 'Ha ocurrido un error al actualizar la informacion del carrito',
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          this.messageResponse(options);
        });

      }

      verificarReglaCoberturaMora(orderData){
        let cartId = this.SessionService.get('cartId') || '';
    
        this.CartService.checkVolumePurchaseRule(cartId).then(response => {
          if(!response.error){
            this.ok();
            // Si continene regla dejamos pasar al tunel
            if(response.aplicaRegla){
              this.guardarDataPedido(orderData);
            }else{
              this.savingOrderCart = false;
            
             let options = {
                title: 'NO ES POSIBLE COMPLETAR EL PEDIDO...',
                isHtml: true,
                content: this.modalOptions.shCtrl.params.cmsInfo.MENSAJE_BODEGA_SUCURSAL_NO_TIENE_COBERTURA,
                size: 'md',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
              };
              return this.messageResponse(options);
            }
          } else{
            let options = {
              title: '',
              isHtml: false,
              content: response.message,
              size: '',
              showBottonCancel: false,
              textActionCancel: '',
              textAction: 'Aceptar'
            };
            return this.messageResponse(options);
          }
        }).catch(reason => {
    
          let options = {
            title: 'Ocurrio un error',
            isHtml: false,
            content: 'Ha ocurrido un error al actualizar el carrito',
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          return this.messageResponse(options);
        });
    
      }

      redirigirZonaPagos(){
          this.state.saving = true;
          let emailUser = this.modalOptions.shCtrl.globals.currentUser.contactEmail;
          let urlAgr = this.ngAuthSettings.site.info.company.urlAgp;

          this.CartService.createToken(emailUser).then(response => {
            if (!response.error) {
              this.state.saving = false;
              let token = response.token;
              this.cancel();
              // Si la url no esta parametrizada mostramos el error
              if(urlAgr != null && urlAgr != ''){
                // Si no contiene http la url se lo añadimos 
                if (urlAgr.substring(0, 4) !== 'http'){
                  urlAgr = 'http://' + urlAgr;
                }
                let urlZonaPagos = urlAgr + '/token/' + token;
                this.$window.open(urlZonaPagos, '_blank');
              }else{
                let options = {
                  title: 'Error',
                  isHtml: false,
                  content: 'Ha ocurrido un error al redirigir a zona de pagos',
                  size: '',
                  showBottonCancel: false,
                  textActionCancel: '',
                  textAction: 'Aceptar'
                };
                this.messageResponse(options);  
              }
            } else {
              this.state.saving = false;
              let options = {
                title: 'Error',
                isHtml: false,
                content: 'Ha ocurrido un error al redirigir a zona de pagos',
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar'
              };
              this.messageResponse(options);
            }
          });
      }

      consultarCartera(){
        this.ok();
      }

      messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
          animation: true,
          template: modalConfirmation,
          controller: 'ModalResponseController',
          controllerAs: 'mdCtrl',
          size: 'md',
          resolve: {
            modalOptions: () => options
          }
        });
        modalInstance.result.then(() => {
          if (callAcept) {
            callback();
          }
        }).catch(reason => {
          if (callCancel) {
            callbackCancel();
          }
        });
      }
}


ModalMoraController.$inject = inject;

export default ModalMoraController;


/** WEBPACK FOOTER **
 ** ./www/components/cart/modal-mora/modal-mora.controller.js
 **/